__turbopack_context__.v({
  "caretBlink": "HoverWord-module-scss-module__uiZ4-G__caretBlink",
  "codeClose": "HoverWord-module-scss-module__uiZ4-G__codeClose",
  "codeSweep": "HoverWord-module-scss-module__uiZ4-G__codeSweep",
  "editor": "HoverWord-module-scss-module__uiZ4-G__editor",
  "editorActive": "HoverWord-module-scss-module__uiZ4-G__editorActive",
  "editorCaret": "HoverWord-module-scss-module__uiZ4-G__editorCaret",
  "editorLine": "HoverWord-module-scss-module__uiZ4-G__editorLine",
  "editorNum": "HoverWord-module-scss-module__uiZ4-G__editorNum",
  "figBounds": "HoverWord-module-scss-module__uiZ4-G__figBounds",
  "figCursor": "HoverWord-module-scss-module__uiZ4-G__figCursor",
  "figDims": "HoverWord-module-scss-module__uiZ4-G__figDims",
  "figDimsBg": "HoverWord-module-scss-module__uiZ4-G__figDimsBg",
  "figDimsIn": "HoverWord-module-scss-module__uiZ4-G__figDimsIn",
  "figDimsOut": "HoverWord-module-scss-module__uiZ4-G__figDimsOut",
  "figDimsText": "HoverWord-module-scss-module__uiZ4-G__figDimsText",
  "figHandle": "HoverWord-module-scss-module__uiZ4-G__figHandle",
  "figIn": "HoverWord-module-scss-module__uiZ4-G__figIn",
  "figLabel": "HoverWord-module-scss-module__uiZ4-G__figLabel",
  "figOut": "HoverWord-module-scss-module__uiZ4-G__figOut",
  "figPop": "HoverWord-module-scss-module__uiZ4-G__figPop",
  "figPopOut": "HoverWord-module-scss-module__uiZ4-G__figPopOut",
  "figTag": "HoverWord-module-scss-module__uiZ4-G__figTag",
  "hint": "HoverWord-module-scss-module__uiZ4-G__hint",
  "hintCaret": "HoverWord-module-scss-module__uiZ4-G__hintCaret",
  "hintCursor": "HoverWord-module-scss-module__uiZ4-G__hintCursor",
  "hintCycle": "HoverWord-module-scss-module__uiZ4-G__hintCycle",
  "hintPet": "HoverWord-module-scss-module__uiZ4-G__hintPet",
  "hintTag": "HoverWord-module-scss-module__uiZ4-G__hintTag",
  "n8": "HoverWord-module-scss-module__uiZ4-G__n8",
  "n8Body": "HoverWord-module-scss-module__uiZ4-G__n8Body",
  "n8Bolt": "HoverWord-module-scss-module__uiZ4-G__n8Bolt",
  "n8Check": "HoverWord-module-scss-module__uiZ4-G__n8Check",
  "n8Dot": "HoverWord-module-scss-module__uiZ4-G__n8Dot",
  "n8Draw": "HoverWord-module-scss-module__uiZ4-G__n8Draw",
  "n8Edge": "HoverWord-module-scss-module__uiZ4-G__n8Edge",
  "n8Grid": "HoverWord-module-scss-module__uiZ4-G__n8Grid",
  "n8Head": "HoverWord-module-scss-module__uiZ4-G__n8Head",
  "n8Hide": "HoverWord-module-scss-module__uiZ4-G__n8Hide",
  "n8Icon": "HoverWord-module-scss-module__uiZ4-G__n8Icon",
  "n8IconOff": "HoverWord-module-scss-module__uiZ4-G__n8IconOff",
  "n8IconOn": "HoverWord-module-scss-module__uiZ4-G__n8IconOn",
  "n8Item": "HoverWord-module-scss-module__uiZ4-G__n8Item",
  "n8Label": "HoverWord-module-scss-module__uiZ4-G__n8Label",
  "n8Node": "HoverWord-module-scss-module__uiZ4-G__n8Node",
  "n8OkFill": "HoverWord-module-scss-module__uiZ4-G__n8OkFill",
  "n8OkStroke": "HoverWord-module-scss-module__uiZ4-G__n8OkStroke",
  "n8Pop": "HoverWord-module-scss-module__uiZ4-G__n8Pop",
  "n8PopOut": "HoverWord-module-scss-module__uiZ4-G__n8PopOut",
  "n8Port": "HoverWord-module-scss-module__uiZ4-G__n8Port",
  "n8Show": "HoverWord-module-scss-module__uiZ4-G__n8Show",
  "n8Spin": "HoverWord-module-scss-module__uiZ4-G__n8Spin",
  "n8Wire": "HoverWord-module-scss-module__uiZ4-G__n8Wire",
  "n8WireOk": "HoverWord-module-scss-module__uiZ4-G__n8WireOk",
  "overlay": "HoverWord-module-scss-module__uiZ4-G__overlay",
  "petEmerge": "HoverWord-module-scss-module__uiZ4-G__petEmerge",
  "petEyes": "HoverWord-module-scss-module__uiZ4-G__petEyes",
  "petGaitA": "HoverWord-module-scss-module__uiZ4-G__petGaitA",
  "petGaitB": "HoverWord-module-scss-module__uiZ4-G__petGaitB",
  "petIdle": "HoverWord-module-scss-module__uiZ4-G__petIdle",
  "petPeek": "HoverWord-module-scss-module__uiZ4-G__petPeek",
  "petRetreat": "HoverWord-module-scss-module__uiZ4-G__petRetreat",
  "petSprite": "HoverWord-module-scss-module__uiZ4-G__petSprite",
  "petStepA": "HoverWord-module-scss-module__uiZ4-G__petStepA",
  "petStepB": "HoverWord-module-scss-module__uiZ4-G__petStepB",
  "selBand": "HoverWord-module-scss-module__uiZ4-G__selBand",
  "suggest": "HoverWord-module-scss-module__uiZ4-G__suggest",
  "suggestDetail": "HoverWord-module-scss-module__uiZ4-G__suggestDetail",
  "suggestMatch": "HoverWord-module-scss-module__uiZ4-G__suggestMatch",
  "suggestRow": "HoverWord-module-scss-module__uiZ4-G__suggestRow",
  "svg": "HoverWord-module-scss-module__uiZ4-G__svg",
  "text": "HoverWord-module-scss-module__uiZ4-G__text",
  "vsMethod": "HoverWord-module-scss-module__uiZ4-G__vsMethod",
  "vs_fn": "HoverWord-module-scss-module__uiZ4-G__vs_fn",
  "vs_kw": "HoverWord-module-scss-module__uiZ4-G__vs_kw",
  "vs_num": "HoverWord-module-scss-module__uiZ4-G__vs_num",
  "vs_pn": "HoverWord-module-scss-module__uiZ4-G__vs_pn",
  "vs_var": "HoverWord-module-scss-module__uiZ4-G__vs_var",
  "word": "HoverWord-module-scss-module__uiZ4-G__word",
});
